/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'
import vueConfig from '../vue.config.js'

import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

//const sentryServerDsn = 'http://f70e2543323d4f07a1a854267572245f@log.bistpay.com:9000/3';
//const sentryServerDsn = 'http://41c2267ddb6d433386e34d54988caff8@192.168.100.89:9000/4';

const sentryServerDsn = 'https://607b1487ccd74cf8a763a910e2eabb76@log.bistpay.com/2';



// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax

Vue.use(Vuesax)


Sentry.init({
  dsn: sentryServerDsn,
  integrations: [new Integrations.Vue({ Vue, attachProps: true, logErrors: true })],
});

//Sentry.captureException("App Started. Sentry Connection is OK - Test Error Log 1");

Vue.prototype.$Sentry = Sentry;
//signalr
var signalR = require("@aspnet/signalr");

Vue.prototype.$signalR = signalR;





// axios
import axios from "./axios.js"
Vue.prototype.$http = axios
const token = localStorage.getItem('accessToken')
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = "Bearer " + token
}
// API Calls
import "./http/requests"

// mock
import "./fake-db/index.js"

// Theme Configurations
import '../themeConfig.js'


// globalObjects
//import './globalObjects.js'
import helper from './helper.js'
Vue.prototype.$helper = helper

//version
Vue.prototype.$version = {
  number: 36,
  name: "2.5",
  date: '1400'
    + 'شهریور'
    + '28'
};


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// i18n
import i18n from './i18n/i18n'


// Vuexy Admin Filters
import './filters/filters'


// Clipboard
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard);


// Tour
import VueTour from 'vue-tour'
Vue.use(VueTour)
require('vue-tour/dist/vue-tour.css')


// VeeValidate
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);


// Google Maps
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    // Add your API key here
    key: 'YOUR_API_KEY',
    libraries: 'places', // This is required if you use the Auto complete plug-in
  },
})

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')


// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';






Vue.config.productionTip = false

store.dispatch("permission/fetchItems").finally(() => {
  // ACL
  let acl = import('./acl/acl');

  new Vue({
    router,
    store,
    i18n,
    acl,
    render: h => h(App)
  }).$mount('#app');

});
